// AWS本番環境設定
export default {
  Auth: {
          region: "ap-northeast-1",
          userPoolId: "ap-northeast-1_iKpGxRjjD",
          userPoolWebClientId: "7a9m8bs4hucrvikfp3549lvuam",
          identityPoolId: "ap-northeast-1:764b85e8-09bc-463b-b2cb-3785fae1f42f"
        },
  API: {
    endpoints : [
      {
        name: "seomportal_v1",
        endpoint: "https://gle3ew10w0.execute-api.ap-northeast-1.amazonaws.com/v1/customer",
        region: "ap-northeast-1"
      }
    ]
  }
}

// AWSステージング環境設定
// export default {
//   Auth: {
//     region: 'ap-northeast-1',
//     userPoolId: 'ap-northeast-1_qaEr1uhDX',
//     userPoolWebClientId: '1rgjdd26nt4optn5sj42bnha4s',
//   },
//   API: {
//     endpoints: [
//       {
//         name: 'seomportal_v1',
//         endpoint: 'https://v2lkpk5k8k.execute-api.ap-northeast-1.amazonaws.com/dev/customer',
//       },
//       {
//         name: 'seomportal_dev',
//         endpoint: 'https://v2lkpk5k8k.execute-api.ap-northeast-1.amazonaws.com/dev/customer',
//       },
//     ],
//   },
// };
